export const SET_HRMS41E_INDEX_DISP = 'SET_HRMS41E_INDEX_DISP'
export const GET_HRMS41E_INDEX_DISP = 'GET_HRMS41E_INDEX_DISP'
export const SET_HRMS41E_DETAIL_DISP = 'SET_HRMS41E_DETAIL_DISP'
export const GET_HRMS41E_DETAIL_DISP = 'GET_HRMS41E_DETAIL_DISP'
export const TOGGLE_HRMS41E_PAGE = 'TOGGLE_HRMS41E_PAGE'
export const SET_HRMS41E_COLUMNS = 'SET_HRMS41E_COLUMNS'
export const GET_HRMS41E_COLUMNS = 'GET_HRMS41E_COLUMNS'
export const SET_HRMS41E_LABELS = 'SET_HRMS41E_LABELS'
export const GET_HRMS41E_LABELS = 'GET_HRMS41E_LABELS'
export const GET_HRMS41E_MAX_ROWSPAN = 'GET_HRMS41E_MAX_ROWSPAN'
export const RECEIVED_HRMS41E_COLUMNS_LABELS = 'RECEIVED_HRMS41E_COLUMNS_LABELS'
export const SET_HRMS41E_INDEX = 'SET_HRMS41E_INDEX'
export const GET_HRMS41E_INDEX = 'GET_HRMS41E_INDEX'
export const SET_HRMS41E_INDEX_SELECTED = 'SET_HRMS41E_INDEX_SELECTED'
export const GET_HRMS41E_INDEX_SELECTED = 'GET_HRMS41E_INDEX_SELECTED'
export const POST_HRMS41E_TAB1_SAVE = 'POST_HRMS41E_TAB1_SAVE'
export const RECEIVED_HRMS41E_INDEX = 'RECEIVED_HRMS41E_INDEX'
export const SET_HRMS41E_DETAIL = 'SET_HRMS41E_DETAIL'
export const GET_HRMS41E_DETAIL = 'GET_HRMS41E_DETAIL'
export const RECEIVED_HRMS41E_DETAIL = 'RECEIVED_HRMS41E_DETAIL'



// WEBPACK FOOTER //
// ./src/store/modules/hrms41e/mutation-types.js